import { render } from "./forget.vue?vue&type=template&id=20e24eee"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"

import "./forget.vue?vue&type=style&index=0&id=20e24eee&lang=less"
script.render = render

export default script